import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import styled from 'styled-components'
import {backArrow, forwardArrow, PlainBackLink} from '../../styledComponents/Links'
import {BlockSpacer, currentMedia} from '../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../styledComponents/DisplayItem'
import {StyledPageTitle} from './components/CommonStyle'
import ResidentReservationTimelineView, {ResidentTimelineItem} from './components/ResidentReservationTimelineView'
import moment, {Moment} from 'moment'
import {Id, PPTimelineGroup, StickyDiv} from './components/ReservationTimelineView'
import {Colors, DisplaySizeValue, FontSize, FontWeights} from '../../styledComponents/Constants'
import FacilitiesRepository from '../facilities/FacilitiesRepository'
import ReservationsRepository from './ReservationsRepository'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {Nullable} from '../../app/TypeHelpers'
import {
    getYearAfterNextDateFac,
    getYearDateFac,
    NatAsyncCallFunction,
} from '../../__NoAutomatedTests/common/util/Natutil'
import FacilityCardInfo from '../facilities/FacilityCardInfo'
import {PlainLinkStyledButton} from '../../styledComponents/Button'
import {RightRowFlexContainer, RowFlexContainer} from '../../styledComponents/FlexComponents'
import {HKConstants} from '../../HKConstants'
import {Popover} from '@mui/material'
import {DateFormatter, DayPicker} from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import './components/DayPicker.css'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {convertToMoment} from './helpers/helpers'
import ReserveAvailabilityDuration from './ReserveAvailabilityDuration'
import {AVAILABLE_OR_NOT, FACILITY_CATEGORY, RESERVATION_STATUS} from '../../CodeMaster'
import {StyledDiv} from '../../styledComponents/StyledTypeDefinitions'
import ReserveAvailabilityOvernight from './ReserveAvailabilityOvernight'
import {
    deserializeFilterConditions,
    filterFacilityInfosByTypeAndCategory,
    serializeFilterConditions,
} from './ResidentFacilityReservationStatusComponents/ResidentFacilityReservationStatusPageHelper'
import {GrayedStatusTag} from './components/ReservationStatusTag'
import {createUUID} from '../../stringHelper/stringHelpers'
import HolidaysRepository from '../HolidaysRepository'
import {formatForDateInput} from '../../formatters/formatDate'
import {format} from 'date-fns'
import {ja} from 'date-fns/locale'
import ScrollableCategorySelector from '../shared/ScrollableCategorySelector'
import {
    RRFTFacilitySearchComponentHelper,
} from './ResidentReserveFacilityTopComponents/RRFTFacilitySearchComponentHelper'
import {ResidentReserveFacilityInputPageLocationState} from './ResidentReserveFacilityInputPage'
import {isWidthDown, WithWidth, WithWidthProps} from '../shared/forms/hoc/withMediaQuery'
// import withWidth, {isWidthDown, WithWidthProps} from '@mui/material/Hidden/withWidth'

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
// const withWidth = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="xs" />;

export const KEY_FACILITY_RESERVATION_STATUS_SEARCH_DATE = 'ResidentFacilityReservationStatusPage.searchDate'
export const KEY_FACILITY_RESERVATION_STATUS_FILTER_CONDITIONS = 'ResidentFacilityReservationStatusPage.filterConditions'

export function setResidentFacilityReservationStatusPageSearchDate(searchDate: Moment): void {
    SessionStorageHelper.setItem(
        KEY_FACILITY_RESERVATION_STATUS_SEARCH_DATE,
        searchDate.format('YYYY-MM-DD'),
    )
}

export function getResidentFacilityReservationStatusPageSearchDate(): Nullable<string> {
    const searchDate: Nullable<string> =
        SessionStorageHelper.getStringItemOrNull(KEY_FACILITY_RESERVATION_STATUS_SEARCH_DATE)
    return searchDate !== null ? searchDate : null
}

export function clearResidentFacilityReservationStatusPageSearchDate(): void {
    SessionStorageHelper.removeItem(KEY_FACILITY_RESERVATION_STATUS_SEARCH_DATE)
}

function setResidentReserveFilterConditions(filterConditions: FilterConditions): void {
    SessionStorageHelper.setItem(
        KEY_FACILITY_RESERVATION_STATUS_FILTER_CONDITIONS,
        serializeFilterConditions(filterConditions),
    )
}

function getResidentReserveFilterConditions(): FilterConditions {
    const json: Nullable<string> =
        SessionStorageHelper.getStringItemOrNull(KEY_FACILITY_RESERVATION_STATUS_FILTER_CONDITIONS)
    return json !== null ? deserializeFilterConditions(json) : {categories: []}
}

export function clearResidentFacilityReservationStatusPageFilterConditions(): void {
    SessionStorageHelper.removeItem(KEY_FACILITY_RESERVATION_STATUS_FILTER_CONDITIONS)
}

interface Props {
    condominiumCd: string
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExResident
    holidaysRepo: HolidaysRepository
}

interface State {
    areaWidth: number
    currentDate: Nullable<Moment>
    facilityInfos: FacilityCardInfo[]

    searchDate: Nullable<Moment>
    calendarAnchorEL: Nullable<HTMLElement>
    reserveAvailabilityDurationList: ReserveAvailabilityDuration[]
    reserveAvailabilityOvernightList: ReserveAvailabilityOvernight[]

    overnightFacilityReservationStatuses: OvernightFacilityReservationStatus[]
    durationFacilityTimelineGroups: PPTimelineGroup[]
    durationFacilityTimelineItems: ResidentTimelineItem[]

    filterConditions: FilterConditions

    isWaitingResponse: boolean
    holidays: string[]
}

interface OvernightFacilityReservationStatus {
    facilityId: number
    facilityName: string
    reserveAvailable: boolean
    status: RESERVATION_STATUS | 'blank'
    ownerName: Nullable<string>
}

export interface FilterConditions {
    categories: FACILITY_CATEGORY[]
}

class ResidentFacilityReservationStatusPage extends Component<Props & ResidentPagePropsSet & WithWidthProps, State> {

    initialDateTime: Nullable<moment.Moment>

    constructor(props: Readonly<Props & ResidentPagePropsSet & WithWidthProps>) {
        super(props)
        this.initialDateTime = null
        this.state = {
            areaWidth: 0,
            currentDate: null,
            facilityInfos: [],
            searchDate: null,
            calendarAnchorEL: null,
            reserveAvailabilityDurationList: [],
            reserveAvailabilityOvernightList: [],
            overnightFacilityReservationStatuses: [],
            durationFacilityTimelineGroups: [],
            durationFacilityTimelineItems: [],
            filterConditions: {
                categories: [],
            },
            isWaitingResponse: false,
            holidays: [],
        }

        this.handleResize = this.handleResize.bind(this)
        this.handleSearchDateClick = this.handleSearchDateClick.bind(this)
        this.handleOnDayClick = this.handleOnDayClick.bind(this)
        this.handleDurationFacilityTimelineGroupClick = this.handleDurationFacilityTimelineGroupClick.bind(this)
        this.handleVisibleRangeChanged = this.handleVisibleRangeChanged.bind(this)
        this.handleChangeCategory = this.handleChangeCategory.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {currentDateTimeRepo, facilitiesRepo, eventEmitter, navigate, condominiumCd} = this.props

        await eventEmitter.showLoading()
        window.addEventListener('resize', this.handleResize)
        try {
            const currentTimeResponse = await NatAsyncCallFunction(
                currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
                navigate,
            )
            if (currentTimeResponse === undefined ||
                currentTimeResponse === null ||
                // @ts-ignore
                currentTimeResponse.details === null) {
                return
            }
            // @ts-ignore
            const currentDateTime: Moment = moment(currentTimeResponse.details.currentDateTime)

            const dateString: Nullable<string> = getResidentFacilityReservationStatusPageSearchDate()
            let searchDate: Moment = currentDateTime
            if (dateString !== null) {
                searchDate = convertToMoment(dateString, null)
            }
            this.initialDateTime = searchDate.clone().hour(8).minute(0).second(0)

            const filterConditions: FilterConditions = getResidentReserveFilterConditions()

            const facilityInfos: Nullable<FacilityCardInfo[]> = await NatAsyncCallFunction(
                facilitiesRepo.getFacilityCardInfos.bind(
                    facilitiesRepo,
                    condominiumCd,
                ), navigate)
            if (facilityInfos === null) {
                return
            }

            const durationFacilities = facilityInfos
                .filter(facility => facility.stayAvailability === AVAILABLE_OR_NOT.UNAVAILABLE)
                .map(facility => {
                    return {
                        id: facility.facilityId,
                        title: facility.facilityName,
                    } as PPTimelineGroup
                })
            const loadingItems = this.extractLoadingItems(
                facilityInfos.filter(facility => facility.stayAvailability === AVAILABLE_OR_NOT.UNAVAILABLE),
                searchDate,
            )

            const minDate: string = getYearDateFac()
            const maxDate: string = getYearAfterNextDateFac(currentDateTime.toLocaleString())
            const holidays: Nullable<string[]> =
                await this.getHolidays(formatForDateInput(minDate), formatForDateInput(maxDate))
            this.setState({
                isWaitingResponse: true,
                searchDate: searchDate,
                currentDate: currentDateTime,
                facilityInfos: facilityInfos,
                filterConditions: filterConditions,
                durationFacilityTimelineGroups: durationFacilities,
                overnightFacilityReservationStatuses: [],
                reserveAvailabilityOvernightList: [],
                reserveAvailabilityDurationList: [],
                durationFacilityTimelineItems: loadingItems,
                holidays: holidays === null ? [] : holidays,
            }, async () => {
                this.handleResize()
                try {
                    await Promise.all([
                        ...this.updateReserveStatusForOvernight(),
                        ...this.updateReserveStatusForDuration(),
                    ])
                    this.setState({isWaitingResponse: false})
                } catch (e) {
                    this.props.log.error(e)
                }
            })

        } finally {
            eventEmitter.closeLoading()
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.handleResize)
    }

    async getHolidays(startDate: string, endDate: string): Promise<Nullable<string[]>> {
        try {
            return await NatAsyncCallFunction(
                this.props.holidaysRepo.getHolidays.bind(
                    this.props.holidaysRepo,
                    startDate,
                    endDate,
                ),
                this.props.navigate,
            )
        } catch (e) {
            throw e
        }
    }

    extractLoadingItems(facilities: FacilityCardInfo[], date: moment.Moment): ResidentTimelineItem[] {
        return facilities.map(facility => {
            return {
                type: 'loading',
                id: `${facility.facilityId}-loading`,
                group: facility.facilityId,
                contents: 'データ取得中…',
                start_time: date.clone().hour(0).valueOf(),
                end_time: date.clone().add(1, 'day').valueOf(),
            }
        })
    }

    updateReserveStatusForOvernight(): Promise<void>[] {
        const {searchDate, facilityInfos} = this.state
        if (searchDate === null) {
            return []
        }
        const overnightFacilities: FacilityCardInfo[] = facilityInfos
            .filter(facilityInfo => facilityInfo.stayAvailability === AVAILABLE_OR_NOT.AVAILABLE)

        return overnightFacilities.map(facility => {
            return NatAsyncCallFunction(
                this.getReserveAvailabilityForOvernightForWeek.bind(
                    this,
                    facility.facilityId,
                    searchDate,
                ),
                this.props.navigate,
            ).then((reserveAvailabilityOvernight: Nullable<ReserveAvailabilityOvernight>) => {
                if (reserveAvailabilityOvernight === null) {
                    this.props.log.error('reserveAvailabilityOvernight was null.', facility.facilityId, searchDate)
                    return
                }
                const {reserveAvailableList, currentReserves: myReservations} = reserveAvailabilityOvernight
                const reserveAvailableOfSearchDate = reserveAvailableList
                    .find(reserveAvailable => searchDate.isSame(moment(reserveAvailable.date), 'date'))
                const myReservationOfSearchDate = myReservations.find(myReservation => {
                    const startDate = moment(myReservation.startDate)
                    const endDate = startDate.clone().add(myReservation.stayCount, 'day')
                    return searchDate.isBetween(startDate, endDate, 'day', '[)')
                })

                let status: RESERVATION_STATUS | 'blank' = 'blank'
                let ownerName: Nullable<string> = null
                if (myReservationOfSearchDate) {
                    status = myReservationOfSearchDate.status
                    ownerName = myReservationOfSearchDate.ownerName
                }
                this.setState(prevState => {
                    return {
                        reserveAvailabilityOvernightList: [
                            ...prevState.reserveAvailabilityOvernightList,
                            reserveAvailabilityOvernight,
                        ],
                        overnightFacilityReservationStatuses: [
                            ...prevState.overnightFacilityReservationStatuses,
                            {
                                facilityId: facility.facilityId,
                                facilityName: facility.facilityName,
                                reserveAvailable:
                                    reserveAvailableOfSearchDate
                                        ? reserveAvailableOfSearchDate.reserveAvailable
                                        : false,
                                status: status,
                                ownerName: ownerName,
                            } as OvernightFacilityReservationStatus,
                        ],
                    }
                })
            })
        })
    }

    updateReserveStatusForDuration(): Promise<void>[] {
        const {searchDate, facilityInfos} = this.state
        if (searchDate === null) {
            return []
        }
        const durationFacilities: FacilityCardInfo[] = facilityInfos
            .filter(facilityCardInfo => facilityCardInfo.stayAvailability === AVAILABLE_OR_NOT.UNAVAILABLE)

        return durationFacilities.map(async facility => {
            return NatAsyncCallFunction(
                this.getReserveAvailabilityForDuration.bind(
                    this,
                    facility.facilityId,
                    searchDate,
                ),
                this.props.navigate,
            ).then((reserveAvailabilityDuration: Nullable<ReserveAvailabilityDuration>) => {
                if (reserveAvailabilityDuration == null) {
                    this.props.log.error('reserveAvailabilityDuration was null.', facility.facilityId, searchDate)
                    return
                }
                const currentReserves: ResidentTimelineItem[] =
                    reserveAvailabilityDuration.currentReserves.map(currentReserve => {
                        return {
                            type: 'myReservation',
                            id: currentReserve.id,
                            group: facility.facilityId,
                            contents: '',
                            start_time:
                                moment(currentReserve.startDateTime).valueOf(),
                            end_time:
                                moment(currentReserve.endDateTime).valueOf(),
                        } as ResidentTimelineItem
                    })
                const reserveAvailables: ResidentTimelineItem[] =
                    reserveAvailabilityDuration.reserveAvailableList.map(reserveAvailable => {
                        return {
                            type: 'blank',
                            id: createUUID(),
                            group: facility.facilityId,
                            contents: '',
                            start_time:
                                convertToMoment(
                                    reserveAvailable.startDate, reserveAvailable.startTime).valueOf(),
                            end_time:
                                convertToMoment(
                                    reserveAvailable.endDate, reserveAvailable.endTime).valueOf(),
                        } as ResidentTimelineItem
                    })

                this.setState(prevState => {
                    const removeLoadingItem = prevState.durationFacilityTimelineItems.filter(item => {
                        return item.id !== `${facility.facilityId}-loading`
                    })

                    return {
                        reserveAvailabilityDurationList: [
                            ...prevState.reserveAvailabilityDurationList,
                            reserveAvailabilityDuration,
                        ],
                        durationFacilityTimelineItems: [
                            ...removeLoadingItem,
                            ...reserveAvailables,
                            ...currentReserves,
                        ],
                    }
                })
            })
        })
    }

    getReserveAvailabilityForOvernightForWeek(
        facilityId: number,
        searchDate: Moment,
    ): Promise<ReserveAvailabilityOvernight> {
        const {reservationsRepo, condominiumCd} = this.props

        const startDateString: string = searchDate.format('YYYY-MM-DD')

        return reservationsRepo.getReserveStatusForOvernightRental(
            condominiumCd,
            facilityId,
            null,
            startDateString,
            7,
        )
    }

    getReserveAvailabilityForDuration(
        facilityId: number,
        searchDate: Moment,
    ): Promise<ReserveAvailabilityDuration> {
        const {reservationsRepo, condominiumCd} = this.props

        return reservationsRepo.getReserveStatusForDurationDetail(
            condominiumCd,
            facilityId,
            searchDate.format('YYYY-MM-DD'),
        )
    }

    handleResize(): void {
        const spMode = isWidthDown(this.props.width, true)
        const areaWidth = window.innerWidth - (spMode ? 0 : 30)
        if (this.state.areaWidth !== areaWidth) {
            this.setState({
                areaWidth: Math.max(DisplaySizeValue.ResidentWidthMin, areaWidth),
            })
        }
    }

    handleChangeCategory(selectedCategory: FACILITY_CATEGORY[]): void {
        const {filterConditions} = this.state
        filterConditions.categories = selectedCategory
        setResidentReserveFilterConditions(filterConditions)
        this.setState({
            filterConditions: filterConditions,
        })
    }

    handleSearchDateClick(event: React.MouseEvent<HTMLElement>): void {
        this.setState({
            calendarAnchorEL: event.currentTarget,
        })
    }

    handleOnDayClick(day: Date): void {
        const newSearchDate = moment(day).hour(8).minutes(0).second(0)
        setResidentFacilityReservationStatusPageSearchDate(newSearchDate)

        const {facilityInfos} = this.state
        const loadingItems = this.extractLoadingItems(
            facilityInfos.filter(facility => facility.stayAvailability === AVAILABLE_OR_NOT.UNAVAILABLE),
            newSearchDate,
        )

        this.setState({
                isWaitingResponse: true,
                calendarAnchorEL: null,
                searchDate: newSearchDate,
                overnightFacilityReservationStatuses: [],
                reserveAvailabilityOvernightList: [],
                reserveAvailabilityDurationList: [],
                durationFacilityTimelineItems: loadingItems,
            }, async () => {
                this.initialDateTime = this.state.searchDate
                try {
                    await Promise.all([
                        ...this.updateReserveStatusForOvernight(),
                        ...this.updateReserveStatusForDuration(),
                    ])
                    this.setState({isWaitingResponse: false})
                } catch (e) {
                    this.props.log.error(e)
                }
            },
        )
    }

    handleClickChangeDay(offset: number, initialVisibleStart: Nullable<moment.Moment> = null): void {
        if (this.state.isWaitingResponse) {
            return
        }
        const {searchDate, facilityInfos} = this.state
        if (searchDate === null) {
            return
        }
        const newSearchDate = searchDate.clone().add(offset, 'day').hour(8).minute(0).second(0)
        setResidentFacilityReservationStatusPageSearchDate(newSearchDate)

        const loadingItems = this.extractLoadingItems(
            facilityInfos.filter(facility => facility.stayAvailability === AVAILABLE_OR_NOT.UNAVAILABLE),
            newSearchDate,
        )

        this.setState({
                isWaitingResponse: true,
                searchDate: (initialVisibleStart !== null)
                    ? initialVisibleStart
                    : newSearchDate,
                overnightFacilityReservationStatuses: [],
                reserveAvailabilityOvernightList: [],
                reserveAvailabilityDurationList: [],
                durationFacilityTimelineItems: loadingItems,
            }, async () => {
                this.initialDateTime = this.state.searchDate
                try {
                    await Promise.all([
                        ...this.updateReserveStatusForOvernight(),
                        ...this.updateReserveStatusForDuration(),
                    ])
                    this.setState({isWaitingResponse: false})
                } catch (e) {
                    this.props.log.error(e)
                }
            },
        )
    }

    handleClickPrevDay = () => this.handleClickChangeDay(-1)
    handleClickNextDay = () => this.handleClickChangeDay(1)

    handleOvernightFacilityNameClick(facilityId: number): void {
        const {condominiumCd} = this.props
        const {facilityInfos, searchDate} = this.state
        const selectedFacilityId = facilityId

        const selectedFacility = facilityInfos
            .find(facility => facility.facilityId === selectedFacilityId)
        if (selectedFacility === undefined) {
            return
        }
        if (searchDate === null) {
            return
        }

        const locationState: ResidentReserveFacilityInputPageLocationState = {
            previousPageUrl: `/resident/condominiums/${condominiumCd}/facilities/reservation-status`,
            overnight: {
                startDate: searchDate.format('YYYY-MM-DD'),
                stayCount: null,
            },
        }

        this.props.navigate(
            `/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reserve/input`,
            {state: locationState},
        )
    }

    handleDurationFacilityTimelineGroupClick(groupId: Id): void {
        const {condominiumCd} = this.props
        const {facilityInfos, searchDate} = this.state
        const selectedFacilityId = Number(groupId)

        const selectedFacility = facilityInfos
            .find(facility => facility.facilityId === selectedFacilityId)
        if (selectedFacility === undefined) {
            return
        }
        if (searchDate === null) {
            return
        }

        const locationState: ResidentReserveFacilityInputPageLocationState = {
            previousPageUrl: `/resident/condominiums/${condominiumCd}/facilities/reservation-status`,
            duration: {
                startDate: searchDate.format('YYYY-MM-DD'),
                startTime: null,
                endDate: searchDate.format('YYYY-MM-DD'),
                endTime: null,
            },
        }

        this.props.navigate(
            `/resident/condominiums/${condominiumCd}/facilities/${groupId}/reserve/input`,
            {state: locationState},
        )
    }

    renderFilterFacility(): ReactNode {
        const {facilityInfos, filterConditions} = this.state

        const categorySet: Set<FACILITY_CATEGORY> = new Set<FACILITY_CATEGORY>()
        const facilityTypeSet: Set<AVAILABLE_OR_NOT> = new Set<AVAILABLE_OR_NOT>()
        facilityInfos.forEach(info => {
            categorySet.add(info.category)
            facilityTypeSet.add(info.stayAvailability)
        })
        if (categorySet.size <= 1 && facilityTypeSet.size <= 1) {
            return null
        }
        const facilityCategoryList = RRFTFacilitySearchComponentHelper.extractFacilityCategories(facilityInfos)

        const categories = filterConditions && filterConditions.categories

        return (<>
            <FilterFacility>
                <MarginSetting>
                    <ScrollableCategorySelector
                        onChangeCategory={this.handleChangeCategory}
                        categoryList={facilityCategoryList}
                        selectedCategoryList={categories}
                        displayAllButton
                    />
                </MarginSetting>
            </FilterFacility>
        </>)
    }

    renderDayNavigation(): ReactNode {
        const {searchDate, currentDate, calendarAnchorEL, holidays} = this.state

        if (searchDate == null || currentDate == null) {
            return null
        }

        let prevDayLink: ReactNode = (
            <PrevDay
                disabled={this.state.isWaitingResponse}
                onClick={this.handleClickPrevDay}>前日</PrevDay>
        )
        if (searchDate.isSameOrBefore(`${HKConstants.VMN.FAC.MIN_SELECTABLE_YEAR}-01-01`, 'day')) {
            prevDayLink = (<BlockSpacer width={'50px'}/>)
        }

        let nextDayLink: ReactNode = (
            <NextDay
                disabled={this.state.isWaitingResponse}
                onClick={this.handleClickNextDay}>翌日</NextDay>
        )
        if (searchDate.isSameOrAfter(`${currentDate.year() + 1}-12-31`, 'day')) {
            nextDayLink = (<BlockSpacer width={'50px'}/>)
        }
        const holidayList = holidays.map(holiday => new Date(holiday))

        const modifiers = {
            sun: {dayOfWeek: [0]},
            sat: {dayOfWeek: [6]},
            holidays: holidayList,
        }
        const modifiersStyles = {
            sun: {color: '#ff0000'},
            sat: {color: '#0000ff'},
            holidays: {color: '#ff0000'},
        }
        const selectableStartMonth: moment.Moment = moment('2020-01-01 00:00:00')
        const selectableEndMonth: moment.Moment = moment(`${currentDate.year() + 1}-12-31 00:00:00`)

        return (<>
            <DayNavigation>
                <RowFlexContainer>
                    {prevDayLink}
                    <PlainLinkStyledButton
                        onClick={this.handleSearchDateClick}>
                        {searchDate.format('M月D日(ddd)')}
                    </PlainLinkStyledButton>
                    <Popover
                        open={(calendarAnchorEL !== null)}
                        anchorEl={calendarAnchorEL}
                        onClose={() => {
                            this.setState({calendarAnchorEL: null})
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}>
                        <WrappedDayPicker
                            modifiers={modifiers}
                            modifiersStyles={modifiersStyles}
                            fromMonth={selectableStartMonth.toDate()}
                            toMonth={selectableEndMonth.toDate()}
                            selected={
                                (searchDate !== null)
                                    ? [searchDate.toDate()]
                                    : undefined
                            }
                            defaultMonth={(searchDate !== null)
                                ? searchDate.toDate()
                                : undefined
                            }
                            locale={ja}
                            formatters={{formatCaption}}
                            onDayClick={this.handleOnDayClick}
                        />
                    </Popover>
                    {nextDayLink}
                </RowFlexContainer>
            </DayNavigation>
        </>)
    }

    renderOvernightReserveStatus(reserveStatus: OvernightFacilityReservationStatus): ReactNode {
        let facilityReserveStatus: ReactNode
        if (reserveStatus.status !== 'blank') {
            let message: string
            if (reserveStatus.ownerName === null) {
                message = 'あなたが予約しています'
            } else {
                message = `${reserveStatus.ownerName} さんが予約しています`
            }
            facilityReserveStatus = (<>
                <GrayedStatusTag>{reserveStatus.status.label}</GrayedStatusTag>
                <ReserveAvailability>{message}</ReserveAvailability>
            </>)
        } else if (reserveStatus.reserveAvailable) {
            facilityReserveStatus = (<ReserveAvailability>○ 空きあり</ReserveAvailability>)
        } else {
            facilityReserveStatus = (<ReserveAvailability>× 予約できません</ReserveAvailability>)
        }
        return facilityReserveStatus
    }

    renderOvernightFacilityReservationStatus(): ReactNode {
        const {overnightFacilityReservationStatuses, facilityInfos, filterConditions} = this.state
        const filteredFacilityInfos: FacilityCardInfo[] =
            filterFacilityInfosByTypeAndCategory(facilityInfos, filterConditions)
                .filter(facility => facility.stayAvailability === AVAILABLE_OR_NOT.AVAILABLE)
        const filteredFacilityIds = filteredFacilityInfos.map(facility => facility.facilityId)
        const filteredOvernightFacilityReservationStatuses = overnightFacilityReservationStatuses
            .filter(status => {
                return filteredFacilityIds.includes(status.facilityId)
            })

        if (filteredFacilityInfos.length === 0) {
            return null
        }

        return (<>
            <BlockSpacer height={'15px'}/>
            <Subtitle>
                宿泊施設
            </Subtitle>
            <BlockSpacer height={'15px'}/>
            <OvernightTable>
                <tbody>
                {
                    filteredFacilityInfos.map(facilityInfo => {
                        const facilityId: number = facilityInfo.facilityId
                        const reserveStatus =
                            filteredOvernightFacilityReservationStatuses
                                .find(reserve => reserve.facilityId === facilityId)
                        return (
                            <OvernightTableRow key={facilityId}>
                                <OvernightTableFacilityName>
                                    <FacilityNameLinkButton
                                        onClick={this.handleOvernightFacilityNameClick.bind(this, facilityId)}
                                    >
                                        {facilityInfo.facilityName}
                                    </FacilityNameLinkButton>
                                </OvernightTableFacilityName>
                                <OvernightTableData dataLoading={(reserveStatus === undefined)}>
                                    {reserveStatus ? this.renderOvernightReserveStatus(reserveStatus) : 'データ取得中…'}
                                </OvernightTableData>
                            </OvernightTableRow>
                        )
                    })
                }
                </tbody>
            </OvernightTable>
        </>)
    }

    handleVisibleRangeChanged(
        visibleTimeStart: number,
        visibleTimeEnd: number,
    ): any {
        if (this.state.searchDate === null) {
            return
        }
        const start: moment.Moment = moment(visibleTimeStart)
        const end: moment.Moment = moment(visibleTimeEnd)
        if (end.isBefore(this.state.searchDate.clone().startOf('day'))) {
            this.handleClickChangeDay(-1, moment(visibleTimeStart))
            return
        }
        if (start.isAfter(this.state.searchDate.clone().endOf('day'))) {
            this.handleClickChangeDay(1, moment(visibleTimeStart))
            return
        }
    }

    renderDurationFacilityReservationStatus(): ReactNode {
        const {
            facilityInfos,
            filterConditions,
            durationFacilityTimelineGroups,
            durationFacilityTimelineItems,
            searchDate,
        } = this.state
        if (searchDate === null || this.initialDateTime === null) {
            return null
        }

        const filteredFacilityInfos: FacilityCardInfo[] =
            filterFacilityInfosByTypeAndCategory(facilityInfos, filterConditions)
                .filter(facility => facility.stayAvailability === AVAILABLE_OR_NOT.UNAVAILABLE)
        const filteredFacilityIds = filteredFacilityInfos.map(facility => facility.facilityId)
        const filteredTimelineGroups = durationFacilityTimelineGroups.filter(group => {
            return filteredFacilityIds.includes(Number(group.id))
        })
        const filteredTimelineItems = durationFacilityTimelineItems.filter(item => {
            return filteredFacilityIds.includes(Number(item.group))
        })

        if (filteredFacilityInfos.length === 0) {
            return null
        }

        return (<>
            <BlockSpacer height={'30px'}/>
            <Subtitle>
                時間貸し施設
            </Subtitle>
            <BlockSpacer height={'15px'}/>
            <RightRowFlexContainer>
                <BlankStatusLegend>空きあり</BlankStatusLegend>
                <MyReservationStatusLegend>あなたの予約</MyReservationStatusLegend>
                <FilledStatusLegend>予約不可</FilledStatusLegend>
            </RightRowFlexContainer>
            <BlockSpacer height={'10px'}/>
            <TimeLineViewContainer>
                <StickyDiv>
                    <ResidentReservationTimelineView
                        initialVisibleStartDateTime={this.initialDateTime}
                        areaWidth={this.state.areaWidth}
                        groups={filteredTimelineGroups}
                        items={filteredTimelineItems}
                        onGroupClick={this.handleDurationFacilityTimelineGroupClick}
                        onVisibleRangeChanged={this.handleVisibleRangeChanged}
                    />
                </StickyDiv>
            </TimeLineViewContainer>
        </>)
    }

    render(): ReactNode {
        const {searchDate} = this.state
        if (searchDate === null) {
            return null
        }
        return <>
            <PlainBackLink to={`/resident/condominiums/${this.props.condominiumCd}/reserve-facility-top`}>
                戻る
            </PlainBackLink>
            <BlockSpacer height={'16px'}/>
            <DisplayItemDividerForPageTop/>
            <BlockSpacer height={'30px'}/>
            <PageTitle>
                利用日から探す
            </PageTitle>
            <BlockSpacer height={'20px'}/>
            {this.renderFilterFacility()}
            <BlockSpacer height={'2px'}/>
            {this.renderDayNavigation()}
            <BlockSpacer height={'15px'}/>
            {this.renderOvernightFacilityReservationStatus()}
            {this.renderDurationFacilityReservationStatus()}
        </>
    }
}

export default WithWidth(createResidentPage(ResidentFacilityReservationStatusPage))

const formatCaption: DateFormatter = (date, options) => {
    const y = new Date(date.toLocaleString('ja')).getFullYear()
    const m = format(date, 'MM', {locale: ja})
    return `${y}年 ${Number(m)}月`
}

const PageTitle = styled(StyledPageTitle)`
  line-height: 1;
`

const Subtitle: StyledDiv = styled.div`
  line-height: 1;
  font-size: ${FontSize.Body};
  color: ${Colors.AccentDark};
  font-weight: ${FontWeights.Bold};
`

const FilterFacility = styled.div`
  padding: 5px 15px 0;
  ${currentMedia.lessThan('sp')`
    margin: 0 -15px;
  `};
  font-size: ${FontSize.Middle};
  line-height: 1.5;
  color: ${Colors.AccentDark};
  background-color: ${Colors.Surface};
`

const SingleLineText = styled.div`
  line-height: 1;
`

const DayNavigation = styled(SingleLineText)`
  padding: 17px 15px;
  ${currentMedia.lessThan('sp')`
    margin: 0 -15px;
  `};
  font-size: ${FontSize.Body};
  line-height: ${FontSize.Body};
  background-color: ${Colors.Surface};
`

const MarginSetting = styled.div`
  margin: 0 -15px 0 -15px;
`

const PrevDay = styled(PlainLinkStyledButton)`
  position: relative;
  padding-left: 15px;
  text-align: left;
  margin: 0;
  width: 50px;

  :before {
    ${backArrow};
  }
`

const NextDay = styled(PlainLinkStyledButton)`
  position: relative;
  padding-right: 15px;
  text-align: right;
  margin: 0;
  width: 50px;

  :after {
    ${forwardArrow};
  }
`

const TimeLineViewContainer = styled.div`
  background-color: #FFFFFF;
  ${currentMedia.greaterThan('pc')`
      max-width: ${DisplaySizeValue.ResidentWidthMax - (15 * 2)}px;
      margin: auto;
  `}
  ${currentMedia.lessThan('sp')`
      margin-left: -15px;
      margin-right: -15px;
  `}
`

const StatusLegend = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 15px;
  height: 12px;
  line-height: 1;
  color: ${Colors.AccentDark};
  font-size: ${FontSize.Small};

  &::before {
    content: '';
    height: 12px;
    width: 12px;
    display: inline-block;
    margin-right: 3px;
  }
`

const BlankStatusLegend = styled(StatusLegend)`
  &::before {
    background: #FFFFFF;
    border: solid 1px #d9d9d9;
  }
`

const MyReservationStatusLegend = styled(StatusLegend)`
  &::before {
    background: rgb(255, 210, 150);
    border: solid 1px rgba(245, 166, 35, 0.5);
  }
`

const FilledStatusLegend = styled(StatusLegend)`
  &::before {
    background: rgb(227, 227, 227);
    border: solid 1px rgba(112, 112, 112, 0.5);
  }
`

const OvernightTable = styled.table`
  background-color: ${Colors.Surface};
  border-bottom: solid 1px ${Colors.AccentLight};
  border-spacing: 0;
  ${currentMedia.greaterThan('pc')`
      width: 100%;
  `}
  ${currentMedia.lessThan('sp')`
      width: calc(100% + 30px);
      margin-left: -15px;
      margin-right: -15px;
  `};
`

const OvernightTableRow = styled.tr`
  height: 50px;
`

const OvernightTableData = styled.td<{ dataLoading?: boolean }>`
  box-sizing: border-box;
  border-top: solid 1px ${Colors.AccentLight};
  padding-left: 15px;
  font-size: 1.4rem;
  color: #707070;
  background-color: ${props => props.dataLoading ? '#f8f8f8' : 'white'};
`

const OvernightTableFacilityName = styled.td`
  box-sizing: border-box;
  padding: 0 4px;
  border-top: solid 1px ${Colors.AccentLight};
  border-right: solid 1px ${Colors.AccentLight};
  ${currentMedia.greaterThan('pc')`
      width: 245px;
  `}
  ${currentMedia.lessThan('sp')`
      width: 154px;
  `}
`

const FacilityNameLinkButton = styled(PlainLinkStyledButton)`
  font-size: ${FontSize.Small};
  text-align: left;
  height: 49px;
  width: 100%;
  white-space: normal;
  overflow: hidden;
`

const ReserveAvailability = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.Body};
  line-height: 21px;
`

const WrappedDayPicker = styled(DayPicker)`
  word-break: normal;
  line-height: 1.15;

  .rdp-day_today {
    color: #3f51b5;
    font-weight: normal;
  }
`
